var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TerminationOption',{attrs:{"assetComponent":_vm.assetComponent,"form":_vm.form,"currencyCodes":_vm.currencyCodes}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }